import { css, CSSProp } from 'styled-components'

const printCSS = (styles: CSSProp) => css`
  @media print {
    ${styles}
  }
`

export { printCSS }
